// extracted by mini-css-extract-plugin
export default {"box":"TickBox_box__LoGDe","boxNotUsable":"TickBox_boxNotUsable__oMvXi","arrow":"TickBox_arrow__GU7Sk","positionArrow":"TickBox_positionArrow__xnRiL"};